/**
@prop --ux-sf-page-body-padding - Padding for the page body, default is 30px.
@prop --ux-sf-page-body-bg-color - Background color for the page body, default is #fff.
@prop --ux-sf-page-body-color - Primary color for the page body, default is #000.
 */
ux-iws-sf-page-body {
    display: block;
    margin: 0;
    padding: var(--ux-sf-page-body-padding, 30px);
    width: 100%;
    box-sizing: border-box;
    background-color: var(--ux-sf-page-body-bg-color, #fff);
    @include font(light);
    color: var(--ux-sf-page-body-color, #000);

    p,
    h1,
    h2,
    h3,
    h4,
    h5 {
        @include font(light);
        color: currentColor;
        margin-top: 0;
    }

    p:last-of-type {
        margin-bottom: 0;
    }

    &[no-padding] {
        padding: 0;
    }
}
